"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var graphql_request_1 = require("graphql-request");
var Errors_1 = require("./Errors");
var GraphQLConnector = /** @class */ (function () {
    function GraphQLConnector(authManager) {
        this.authManager = authManager;
    }
    GraphQLConnector.prototype.request = function (options) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var urlFromOptions, query, variables, addtlHeaders, authOptions, headers, authState, url, _c, newToken, newAuthState, _d, newToken, newAuthState, response, error_1, requestError;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        urlFromOptions = options.url, query = options.query, variables = options.variables, addtlHeaders = options.headers;
                        authOptions = this.authManager.getOptions(), headers = {};
                        authState = this.authManager.getState();
                        url = urlFromOptions;
                        if (!url) {
                            url = "https://".concat(authOptions.domain, "/graphql");
                            if (authOptions.cors)
                                url = "https://api.fsgchariot.app/graphql";
                        }
                        if (!(authState.authenticated && authState.access_token)) return [3 /*break*/, 4];
                        if (!(+(new Date(authState.expires_at)) < Date.now())) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.authManager.waitForNextToken()];
                    case 1:
                        _c = _e.sent(), newToken = _c[0], newAuthState = _c[1];
                        authState = newAuthState;
                        headers["Authorization"] = "Bearer ".concat(newToken);
                        return [3 /*break*/, 3];
                    case 2:
                        headers["Authorization"] = "Bearer ".concat(authState.access_token);
                        _e.label = 3;
                    case 3: return [3 /*break*/, 7];
                    case 4:
                        if (!authOptions.allowAuthenticatedRequestsBeforeAuthentication) return [3 /*break*/, 5];
                        throw new Errors_1.UnauthenticatedError("Attempted to make an authenticated request before logging in. Try Chariot.login({ email, password }).");
                    case 5: return [4 /*yield*/, this.authManager.waitForNextToken()];
                    case 6:
                        _d = _e.sent(), newToken = _d[0], newAuthState = _d[1];
                        authState = newAuthState;
                        headers["Authorization"] = "Bearer ".concat(newToken);
                        _e.label = 7;
                    case 7:
                        _e.trys.push([7, 9, , 10]);
                        return [4 /*yield*/, (0, graphql_request_1.default)(url, query, variables, __assign(__assign({}, headers), addtlHeaders))];
                    case 8:
                        response = _e.sent();
                        return [2 /*return*/, response];
                    case 9:
                        error_1 = _e.sent();
                        if (error_1 instanceof graphql_request_1.ClientError && error_1.response.errors && error_1.response.errors[0]) {
                            requestError = error_1.response.errors[0];
                            if (requestError) {
                                if (((_b = (_a = requestError.extensions) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.statusCode) == 403) {
                                    throw new Errors_1.UnauthorizedError();
                                }
                                else if (requestError.extensions.code == "GRAPHQL_PARSE_FAILED") {
                                    throw new Errors_1.RequestSyntaxError();
                                }
                                else if (requestError.extensions.code == "GRAPHQL_VALIDATION_FAILED") {
                                    throw new Errors_1.ValidationError(JSON.stringify(requestError));
                                }
                            }
                        }
                        throw error_1;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    GraphQLConnector.prototype.createPaginatedQuery = function (options) {
        return __asyncGenerator(this, arguments, function createPaginatedQuery_1() {
            var field, selectionSet, pageSize, filters, cursor, results, response, _a, _b, data, page, _i, _c, node, _d, endCursor, hasNextPage;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        field = options.field, selectionSet = options.selectionSet, pageSize = options.pageSize, filters = options.filters;
                        cursor = null, results = [];
                        _e.label = 1;
                    case 1: return [4 /*yield*/, __await(this.request({
                            query: (0, graphql_request_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          query paginatedQuery($input: ListRuleEventInput) {\n            ", "(input: $input) {\n              page {\n                edges {\n                  node ", "\n                }\n                pageInfo {\n                  endCursor\n                  hasNextPage\n                }\n              }\n            }\n          }\n        "], ["\n          query paginatedQuery($input: ListRuleEventInput) {\n            ", "(input: $input) {\n              page {\n                edges {\n                  node ", "\n                }\n                pageInfo {\n                  endCursor\n                  hasNextPage\n                }\n              }\n            }\n          }\n        "])), field, selectionSet),
                            variables: {
                                input: {
                                    filters: filters,
                                    pagination: {
                                        after: cursor,
                                        first: pageSize
                                    }
                                }
                            }
                        }))];
                    case 2:
                        response = _e.sent();
                        _a = response, _b = field, data = _a[_b];
                        page = [];
                        for (_i = 0, _c = data.page.edges; _i < _c.length; _i++) {
                            node = _c[_i].node;
                            page.push(node);
                        }
                        _d = data.page.pageInfo, endCursor = _d.endCursor, hasNextPage = _d.hasNextPage;
                        if (hasNextPage) {
                            cursor = endCursor;
                        }
                        else {
                            cursor = null;
                        }
                        results = results.concat(page);
                        return [4 /*yield*/, __await(page)];
                    case 3: return [4 /*yield*/, _e.sent()];
                    case 4:
                        _e.sent();
                        _e.label = 5;
                    case 5:
                        if (cursor) return [3 /*break*/, 1];
                        _e.label = 6;
                    case 6: return [4 /*yield*/, __await(results)];
                    case 7: return [2 /*return*/, _e.sent()];
                }
            });
        });
    };
    return GraphQLConnector;
}());
exports.default = GraphQLConnector;
var templateObject_1;
